module.exports = __webpack_public_path__ + "img/remindBg.f73f189b.png";